import { useQuery } from '@tanstack/react-query';
import { lacAnalyticsService } from '../../../services/LacAnalyticsService';
import type { LacTenantOverviewDateRange } from '../../../types/lac';
import { lacQueryKeys } from '../lacQueryKeys';

export type UseLacPlatformChatAnalyticsQueryOptions = {
  groupByKnowledgeBase?: boolean;
};

export function useLacPlatformChatAnalyticsQuery(
  tenantName: string | undefined,
  range?: LacTenantOverviewDateRange,
  options: UseLacPlatformChatAnalyticsQueryOptions = {},
) {
  const groupByKnowledgeBase = options.groupByKnowledgeBase ?? false;

  return useQuery({
    queryKey: lacQueryKeys.platformChatAnalytics(
      tenantName ?? '',
      range ?? null,
      groupByKnowledgeBase,
    ),
    enabled: Boolean(tenantName),
    queryFn: () => {
      if (!tenantName) {
        throw new Error('Missing tenant name');
      }
      return lacAnalyticsService.listPlatformChatAnalytics({
        tenantName,
        range,
        groupByKnowledgeBase,
      });
    },
  });
}
